import React from 'react';
import './MapSection.css';

const MapSection: React.FC = () => {
  return (
    <div className="map-section">
        <div className='map-text-container'>
            <h2>Punct de lucru – Chirnogi, Călărași</h2>
            <p>
            Neksio Land își are <strong>sediul în Oltenița, cu punct de lucru în comuna Chirnogi, județul Călărași</strong>, la aproximativ 60 de kilometri de București, adică la doar o oră de mers cu mașina. Cu o echipă experimentată și dedicată, activăm în domeniu din 1993 pentru numeroși clienți din întreaga țară.
            <br/>
            De la această locație, ca și de oriunde din țară, oferim servicii de transport și livrare rapide și sigure, asigurând că fiecare comandă ajunge la timp și în cele mai bune condiții. Fie că este vorba despre cereale, îngrășăminte chimice, agregate, materiale pentru construcții sau alte produse, ne angajăm să oferim calitate și profesionalism în tot ceea ce facem.
            </p>
        </div>
        <div className='map-container'>
            <img src='../map-romania.svg' alt='map of Romania'/>
        </div>
    </div>
  );
};

export default MapSection;
